/* eslint-disable @atlassian/relay/graphql-naming */
import React, { useCallback } from 'react';
import { graphql, useFragment } from 'react-relay';
import { FavoriteCell as BaseFavoriteCell } from '@atlassian/jira-directory-base-v3/src/ui/table-cells/favourite-cell/FavoriteCell.tsx';
import { useAnalyticsEvents, fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type { FavoriteCellFavouriteCell$key } from '@atlassian/jira-relay/src/__generated__/FavoriteCellFavouriteCell.graphql';

type Props = {
	project: FavoriteCellFavouriteCell$key;
};

export const FavoriteCell = ({ project }: Props): React.JSX.Element | null => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const analyticsEvent = createAnalyticsEvent({
		action: 'clicked',
		actionSubject: 'resultsTable',
	});

	const data = useFragment<FavoriteCellFavouriteCell$key>(
		graphql`
			fragment FavoriteCellFavouriteCell on JiraProject {
				canViewIssue: action(type: VIEW_ISSUES) {
					canPerform
				}
				...FavoriteCell
			}
		`,
		project,
	);

	const handleClick = useCallback(() => {
		fireUIAnalytics(analyticsEvent, 'FavoriteButton');
	}, [analyticsEvent]);

	return !data.canViewIssue?.canPerform ? null : (
		<BaseFavoriteCell queryRef={data} onClick={handleClick} />
	);
};
